var headerNav = {
    controller : function headerNavCtrl ($element) {
        var ctrl = this;

        function init () {

        }

        function link () {

        }

        this.expandMenu = function expandMenu () {
            ctrl.openNav = !ctrl.openNav;
            ctrl.openSearch = false;
            console.log(ctrl.openNav);
        };

        this.expandSearch = function expandSearch () {
            ctrl.openSearch = !ctrl.openSearch;
            ctrl.openNav = false;
        };

        this.openNav = false;
        this.openSearch = false;
        this.$onInit = init;
        this.$postLink = link;
    },
    transclude : true,
    template : '<div ng-transclude></div>'
};